"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupCloseShopOnFirstBuyListener = void 0;
const models_1 = require("@creature-chess/models");
const ui_1 = require("~/store/game/ui");
const setupCloseShopOnFirstBuyListener = (startListening) => {
    startListening({
        actionCreator: models_1.ClientUi.gameStartedCommand,
        effect: (_action, api) => __awaiter(void 0, void 0, void 0, function* () {
            api.cancelActiveListeners();
            yield api.take((a) => a.type === models_1.PlayerActions.buyCardPlayerAction.type);
            const shopIsOpen = api.getState().game.ui.currentOverlay === ui_1.Overlay.SHOP;
            if (shopIsOpen) {
                api.dispatch((0, ui_1.closeOverlay)());
            }
        }),
    });
};
exports.setupCloseShopOnFirstBuyListener = setupCloseShopOnFirstBuyListener;
